import React, { useState } from 'react'
import { useStateValue } from '../../../state'
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../../../../components'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const ContextToolsRow = ({
    act,
    iteration,
    contextId,
    updateCanvasActs,
    updateContextActs,
    canvasActs
  }) => {
  const [currentState] = useStateValue()
  const [currentActId, setCurrentActId] = useState(act.canvasId)
  const [actNeedsSave, setActNeedsSave] = useState(false)
  const [loading, setLoading] = useState(false)

  const rowIcon = (canvasIdStateInput, externalUrlStateInput) => {
    if (canvasIdStateInput === '' || externalUrlStateInput === '') {
      return null
    }
    let canvasIdState = canvasIdStateInput === 'true'
    let externalUrlState = externalUrlStateInput === 'true'
    if (canvasIdState && externalUrlState) {
      return (
        <i className="fas fa-check-circle fa-lg text-success myed-success" />
      )
    } else if (
      (!canvasIdState && externalUrlState) ||
      (canvasIdState && !externalUrlState) ||
      (!canvasIdState && !externalUrlState)
    ) {
      return (
        <i className="fas fa-exclamation-circle fa-lg text-warning myed-warning" />
      )
    } else {
      return null
    }
  }

  const canvasIdIcon = iconState => {
    if (iconState === 'true') {
      return <i className="fas fa-check text-success myed-success" />
    } else if (iconState === 'false') {
      return <i className="fas fa-exclamation text-warning myed-warning" />
    } else {
      return null
    }
  }

  const canvasActDropdown = (currentCanvasActId, canvasActs) => {
    return (
      <React.Fragment>
        <select value={currentCanvasActId} onChange={handleActChange}>
          <option value="">None</option>
          {canvasActs.map((act, i) => (
            <option value={act.canvasId} key={i}>
              {act.name}
            </option>
          ))}
        </select>
        {actNeedsSave ? (
          <a className="ml-3 fs-normal" onClick={updateMappedAct}>
            Update
          </a>
        ) : null}
      </React.Fragment>
    )
  }

  const handleActChange = e => {
    let canvasAct = canvasActs.find(
      act => act.canvasId === e.target.value
    )
    if (act.canvasId !== e.target.value) {
      setActNeedsSave(true)
    } else {
      setActNeedsSave(false)
    }

    if (canvasAct) {
      setCurrentActId(canvasAct.canvasId)
    } else {
      setCurrentActId('')
    }
  }

  const externalUrlIcon = iconState => {
    if (iconState === 'true') {
      return (
        <div>
          <i className="fas fa-check text-success myed-success" />
        </div>
      )
    } else if (iconState === 'false') {
      return (
        <div>
          <i className="fas fa-exclamation text-warning myed-warning" />
        </div>
      )
    } else {
      return null
    }
  }

  const externalUrlUpdateBtn = externalUrl => {
    if (act.externalUrlMatch === 'true' && externalUrl) {
      return (
        <React.Fragment>
          <div className="fs-normal">{`External Tool URL: ${externalUrl}`}</div>
        </React.Fragment>
      )
    } else if (act.externalUrlMatch !== 'true' && externalUrl) {
      return (
        <React.Fragment>
          <div className="fs-normal">
            {`External Tool URL: ${externalUrl}`}
            <a className="ml-3" onClick={updateExternalUrl}>
              Update URL in Canvas
            </a>
          </div>
        </React.Fragment>
      )
    } else if (
      (act.canvasId && externalUrl === '') ||
      act.externalUrlMatch !== 'true'
    ) {
      return (
        <React.Fragment>
          <div className="fs-normal">
            External Tool URL: None
            <a className="ml-3" onClick={updateExternalUrl}>
              Update URL in Canvas
            </a>
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <div className="fs-normal">External Tool URL: {externalUrl}</div>
        </React.Fragment>
      )
    }
  }

  const updateExternalUrl = async () => {
    setLoading(true)
    let params = {
      coursenum: currentState.contextToolsCoursenum,
      contextId: contextId,
    }
    let data = { myedActId: act.actPk, currentActId }
    try {
      const resp = await client.post(endpoints.updateExternalUrl(params), data)
      updateCanvasActs(resp.data.canvasActs)
      updateContextActs(resp.data.acts)
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    }
    setLoading(false)
  }

  const updateMappedAct = async () => {
    setLoading(true)
    let params = {
      coursenum: currentState.contextToolsCoursenum,
      contextId: contextId,
    }
    let data = { myedActId: act.actPk, currentActId }
    try {
      const resp = await client.post(
        endpoints.updateActMapping({
          coursenum: params.coursenum,
          contextId: params.contextId,
        }),
        data
      )
      updateCanvasActs(resp.data.canvasActs)
      updateContextActs(resp.data.acts)
      setActNeedsSave(false)
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
      })
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <tr
        className={`${iteration > 0 ? 'border-top' : null}`}
        height="100px"
      >
        <td>
          {rowIcon(act['canvasIdMatch'], act['externalUrlMatch'])}
        </td>
        <td>
          <div>{act['myedTitle']}</div>
          <div>guid: {act['guid']}</div>
        </td>
        <td>{canvasIdIcon(act['canvasIdMatch'])}</td>
        <td>{act['canvasId'] ? act['canvasId'] : 'Not Found'}</td>
        <td className="pt-5">
          {externalUrlIcon(act['externalUrlMatch'])}
        </td>
        <td>
          <div>{canvasActDropdown(currentActId, canvasActs)}</div>
          <div>{externalUrlUpdateBtn(act['externalUrl'])}</div>
        </td>
        <td>{loading ? <LoadingSpinner /> : null}</td>
      </tr>
    </React.Fragment>
  )
}

export default ContextToolsRow

ContextToolsRow.propTypes = {
  act: PropTypes.object,
  iteration: PropTypes.number,
  contextId: PropTypes.string,
  updateCanvasActs: PropTypes.func,
  updateContextActs: PropTypes.func,
  canvasActs: PropTypes.array,
}
